export default __webpack_public_path__ + "static/media/mongodb.fb4252f5.png";